import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
	static targets = ['navigation', 'links', 'linkedin', 'searchForm', 'searchButtonContainer'];

	connect() {}

	openSearchForm(e) {
		e.preventDefault();

		this.linksTarget.classList.add('hidden');
		this.linkedinTarget.classList.add('hidden');
		this.searchButtonContainerTarget.classList.add('hidden');
		this.searchFormTarget.classList.remove('hidden');
		this.searchFormTarget.classList.add('flex');
	}

	closeSearchForm(e) {
		e.preventDefault();

		this.linksTarget.classList.remove('hidden');
		this.linkedinTarget.classList.remove('hidden');
		this.searchButtonContainerTarget.classList.remove('hidden');
		this.searchFormTarget.classList.add('hidden');
		this.searchFormTarget.classList.remove('flex');
	}
}
